// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"logo-wall-module--imageContainer--3e7AF","logoBox":"logo-wall-module--logoBox--bFE_l","image":"logo-wall-module--image--1vuWl"};